import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import WveInputButton from 'SharedComponents/WveInputs/WveInputButton/WveInputButton';
import AdStatusDot from 'Components/BuilderTitle/AdStatusDot';
import styled from 'styled-components';
import fontStyles from 'Styles/fonts.scss';
import {
  TOPBAR_HEIGHT,
} from 'SharedConstants/';
import {
  colorBorder,
  colourMasterLightest,
} from 'Styles/colors.css';
import { UI } from 'Reducers/ad/utils';
import { getMetadata } from 'Selectors';

const Bar = styled.div`
  position: fixed;
  padding-left: 10px;
  padding-right: 10px;
  display: block;
  top: 0px;
  height: ${TOPBAR_HEIGHT}px;
  width: 100%;
  z-index: 20;
  background-color: ${colourMasterLightest};
  border-bottom: 1px solid ${colorBorder};
`;

const BreadcrumbsBarInner = styled.div`
  height: ${TOPBAR_HEIGHT}px;
  width: 100%;
  vertical-align: middle;
  line-height: ${TOPBAR_HEIGHT}px;
`;

const BreadcrumbsBar = styled.div`
    float:left;
    width:100%;
`;
const EditButton = styled.div`
    position:fixed;
    right:10px;
`;

const Breadcrumbs = styled.div`
  display: inline-block;
  text-transform: uppercase;
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 0.01em;
  line-height: ${TOPBAR_HEIGHT}px;
  width: 100%;

  > * {
    padding-left: 5px;
    display: inline-block;
    vertical-align: middle;
  }

  div {
    padding-left: 5px;
    vertical-align: middle;
    display: inline-block;
    line-height: ${TOPBAR_HEIGHT}px;
  }

  a {
    text-decoration: none;
    vertical-align: middle;
    display: inline-block;

    &:hover {
      text-decoration: none;
    }
  }
`;

const Button = styled(WveInputButton)`
  margin-right: 20px;
`;

const BreadcrumbText = styled.div`
  max-width: calc(100% - 25px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TopBar = ({
  campaignId,
  campaignName,
  adName,
  logoSrc,
  adId,
  adStatus,
  campaignAccess,
  approveAccess,
  lastUpdated,
}) => (

  <Bar>
    <BreadcrumbsBar>
      <BreadcrumbsBarInner>
        <Breadcrumbs>
          {
            // eslint-disable-next-line max-len
            campaignAccess ? <BreadcrumbText><a href={`/build/libraries/${campaignId}`}>{`${campaignName} `}</a><div>{` / ${adName}`} {`(${adId})`}</div></BreadcrumbText> : <BreadcrumbText>{campaignName} {` / ${adName}`} {`(${adId})`}</BreadcrumbText>
          }
          <div>
            <AdStatusDot status={adStatus} />
          </div>
        </Breadcrumbs>
      </BreadcrumbsBarInner>
    </BreadcrumbsBar>
    <EditButton>
      <BreadcrumbsBarInner>
        { campaignAccess &&
          <a href={`/build/ads/${adId}/edit`} className="btn btn-default btn-xs">Edit</a>
        }
        { approveAccess && (adStatus === 'qa') &&
          <a href={`/build/ads/${adId}/approve`} className="btn btn-success btn-xs bold m-l-10">Approve</a>
        }
      </BreadcrumbsBarInner>
    </EditButton>
  </Bar>
);

TopBar.propTypes = {
  adId: PropTypes.number,
  adStatus: PropTypes.string,
  campaignId: PropTypes.number,
  campaignName: PropTypes.string,
  adName: PropTypes.string,
  logoSrc: PropTypes.string,
  campaignAccess: PropTypes.bool,
  approveAccess: PropTypes.bool,
  lastUpdated: PropTypes.string,
};

TopBar.defaultProps = {
  adId: -1,
  adStatus: 'dev',
  campaignId: -1,
  campaignName: '',
  adName: '',
  logoSrc: '',
  campaignAccess: false,
  approveAccess: false,
  lastUpdated: '',
};

const mapStateToProps = state => ({
  adId: getMetadata(state).get('id'),
  adStatus: getMetadata(state).get('status'),
  campaignId: getMetadata(state).get('campaignId'),
  campaignName: getMetadata(state).get('campaignName'),
  adName: getMetadata(state).get('name'),
  logoSrc: state.getIn([UI, 'logoSrc']),
  campaignAccess: state.getIn([UI, 'campaignAccess']),
  approveAccess: state.getIn([UI, 'approveAccess']),
  lastUpdated: getMetadata(state).get('updated_at'),
});


export default connect(mapStateToProps)(TopBar);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/TopBar/TopBar.jsx